import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignsService extends BaseService {
  constructor(private http: HttpClient) { super(); }

  getCombo(): Observable<any> {
    return this.http.get(this.getUrl(`Campaigns/GetCombo/`));
  }
}
